<template>
  <div id="app-home" class="page in-app">

    <div id="wallpaper">
      <figure></figure>
    </div>

    <section id="ui">
      <app-sidebar></app-sidebar>
      <main>
        <div id="core">
          <div id="content">

            <section id="search-field">
              <search-toolbar />
            </section>

            <home v-if="!showSearchResults"/>

            <search v-else/>

          </div>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
import Sidebar from '@/components/common/Sidebar'
import SearchToolbar from '@/components/common/SearchToolbar'
import Home from '@/components/Home'
import Search from '@/components/Search'

import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    'app-sidebar': Sidebar,
    'search-toolbar': SearchToolbar,
    'home': Home,
    'search': Search
  },
  computed: {
    ...mapGetters({
      showSearchResults: 'search/showSearchResults'
    })
  }
}
</script>
<style lang="scss">
@import "@/styles/views/home/_home.scss";
</style>
